module.exports = {"442000001000":"石岐区街道办事处","442000002000":"东区街道办事处","442000003000":"火炬开发区街道办事处","442000004000":"西区街道办事处","442000005000":"南区街道办事处","442000006000":"五桂山街道办事处","442000100000":"小榄镇","442000101000":"黄圃镇","442000102000":"民众镇","442000103000":"东凤镇","442000104000":"东升镇","442000105000":"古镇镇","442000106000":"沙溪镇","442000107000":"坦洲镇","442000108000":"港口镇","442000109000":"三角镇","442000110000":"横栏镇","442000111000":"南头镇","442000112000":"阜沙镇","442000113000":"南朗镇","442000114000":"三乡镇","442000115000":"板芙镇","442000116000":"大涌镇","442000117000":"神湾镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/442000.json
// module id = 2055
// module chunks = 0